import _scan from "./scan";
import _parse from "./parse";
var exports = {};
var scan = _scan;
var parse = _parse;

exports = function (source) {
  return parse(scan(source));
};

export default exports;